var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-row',[_c('PreviewCatalogXml'),_c('RequiredFieldTable'),_c('AdditionalFields')],1)}
var staticRenderFns = []

export { render, staticRenderFns }